/* The shore: a short film at the foot of What We Leave In Color. */
(function () {
  window.SA_SHORE_SM = window.SA_SHORE_SM || 'https://cdn.shopify.com/videos/c/vp/128432bde362478083695f360de94854/128432bde362478083695f360de94854.HD-720p-4.5Mbps-96285460.mp4';
  var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var src = (small && window.SA_SHORE_SM) || window.SA_SHORE, sec = document.querySelector('[data-colors]');
  if (!src || !sec || sec.querySelector('.sa-shore')) return;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt) n.textContent = txt; return n; }

  var wrap = el('div', 'sa-shore sa-shore__in');
  var glow = el('canvas', 'sa-shore__glow'); glow.width = 32; glow.height = 18; glow.setAttribute('aria-hidden', 'true');
  var frame = el('div', 'sa-shore__frame');
  var v = el('video', 'sa-shore__film');
  v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
  v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
  v.setAttribute('preload', 'none'); v.setAttribute('disablepictureinpicture', '');
  v.setAttribute('aria-label', 'Shirts in every color left at the water’s edge at dusk, balloons tied to a suitcase');
  var bar = el('i', 'sa-shore__bar');
  frame.appendChild(v); frame.appendChild(bar);
  var cap = el('p', 'sa-shore__cap sa-mono');
  var snd = el('button', 'sa-shore__snd'); snd.type = 'button'; snd.setAttribute('aria-pressed', 'false'); snd.setAttribute('aria-label', 'Sound of the tide');
  var NS = 'http://www.w3.org/2000/svg', ico = document.createElementNS(NS, 'svg');
  [['viewBox', '0 0 20 14'], ['width', '17'], ['height', '12'], ['fill', 'none'], ['stroke', 'currentColor'], ['stroke-width', '1.2'], ['stroke-linecap', 'round'], ['stroke-linejoin', 'round'], ['aria-hidden', 'true']].forEach(function (a) { ico.setAttribute(a[0], a[1]); });
  var p1 = document.createElementNS(NS, 'path'); p1.setAttribute('d', 'M1 5h3l4-3.5v11L4 9H1z');
  var p2 = document.createElementNS(NS, 'path'); p2.setAttribute('d', 'M11.5 4.5a3.5 3.5 0 0 1 0 5M14 2.5a6.5 6.5 0 0 1 0 9'); p2.setAttribute('class', 'sa-shore__w');
  ico.appendChild(p1); ico.appendChild(p2); snd.appendChild(ico);
  /* the world: a faint mark that, once noticed, says the line and leads somewhere else */
  var world = el('a', 'sa-shore__world'); world.href = 'https://ithinktheworldofyou.com'; world.target = '_blank'; world.rel = 'noopener';
  world.setAttribute('aria-label', 'i think the world of you');
  var globe = document.createElementNS(NS, 'svg');
  [['viewBox', '0 0 14 14'], ['width', '11'], ['height', '11'], ['fill', 'none'], ['stroke', 'currentColor'], ['stroke-width', '1'], ['aria-hidden', 'true']].forEach(function (a) { globe.setAttribute(a[0], a[1]); });
  ['M7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1z', 'M1 7h12', 'M7 1c2 1.7 2 10.3 0 12M7 1c-2 1.7-2 10.3 0 12'].forEach(function (d) { var q = document.createElementNS(NS, 'path'); q.setAttribute('d', d); globe.appendChild(q); });
  var line = el('span', 'sa-shore__line', 'i think the world of you…');
  world.appendChild(globe); world.appendChild(line);
  world.addEventListener('click', function (e) {
    if (world.classList.contains('is-open')) return;
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    e.preventDefault(); world.classList.add('is-open');
  });
  cap.appendChild(world);
  cap.appendChild(snd);
  wrap.appendChild(glow); wrap.appendChild(frame); wrap.appendChild(cap);
  (sec.querySelector('.sa-colors__grid') || sec).appendChild(wrap);
  sec.classList.add('has-shore');

  /* Two stills, kept small under the film. Tap to see one whole. */
  var stills = window.SA_STILLS || [
    ['https://cdn.shopify.com/s/files/1/0970/5301/6361/files/sa-shore-still-1.jpg?v=1791006747', 1792, 2400, 'A suitcase of shirts in every color on the wet sand at dusk, balloons tied above it'],
    ['https://cdn.shopify.com/s/files/1/0970/5301/6361/files/sa-shore-still-2.jpg?v=1791006747', 2752, 1536, 'Two open suitcases and the shirts laid out on the sand, seen from above as the tide comes in']
  ];
  var css = el('style');
  css.textContent = '.sa-shore.sa-shore__in{position:relative;width:100%;max-width:440px;margin:0 auto}' +
    '.sa-shore__in .sa-shore__frame{border-radius:12px;animation:none;clip-path:none}' +
    '.sa-shore__in .sa-shore__glow{filter:blur(28px) saturate(1.2)}' +
    '.sa-shore__in .sa-shore__cap{margin-top:8px;min-height:26px}' +
    '.sa-shore__in .sa-shore__snd{margin-left:0;padding:6px 0 6px 6px;line-height:0;opacity:.45}' +
    '.sa-shore__world{display:inline-flex;align-items:center;gap:7px;margin-left:auto;padding:6px 0;color:inherit;text-decoration:none;opacity:.3;transition:opacity .5s;-webkit-tap-highlight-color:transparent}' +
    '.sa-shore__world svg{flex:none;animation:sa-world-turn 17s linear infinite}' +
    '.sa-shore__line{max-width:0;overflow:hidden;white-space:nowrap;font:italic 400 14px/1.2 Cormorant Garamond,Georgia,serif;letter-spacing:0;text-transform:none;opacity:0;transition:max-width 1.1s cubic-bezier(.2,.7,.2,1),opacity .8s}' +
    '.sa-shore__world:hover,.sa-shore__world:focus-visible,.sa-shore__world.is-open{opacity:1}' +
    '.sa-shore__world:hover .sa-shore__line,.sa-shore__world:focus-visible .sa-shore__line,.sa-shore__world.is-open .sa-shore__line{max-width:200px;opacity:1}' +
    '@keyframes sa-world-turn{to{transform:rotate(1turn)}}' +
    '@media (prefers-reduced-motion:reduce){.sa-shore__world svg{animation:none}}' +
    '.sa-shore__w{opacity:0;transition:opacity .3s}.sa-shore.is-loud .sa-shore__w{opacity:1}' +
    '.sa-shore__stills{display:flex;gap:5px;align-items:center}' +
    '.sa-shore__still{appearance:none;-webkit-appearance:none;border:0;padding:0;margin:0;background:#8f7fb3;height:26px;border-radius:4px;overflow:hidden;cursor:zoom-in;display:block;opacity:.4;transition:opacity .4s;-webkit-tap-highlight-color:transparent}' +
    '.sa-shore__still:hover,.sa-shore__still:focus-visible{opacity:1}' +
    '.sa-shore__still img{display:block;width:100%;height:100%;object-fit:cover}' +
    '.sa-shore__still:focus-visible{outline:1px solid currentColor;outline-offset:2px}' +
    '.sa-shore__view{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:4vmin;background:rgba(14,12,28,.94);cursor:zoom-out;opacity:0;transition:opacity .35s}' +
    '.sa-shore__view.is-on{opacity:1}' +
    '.sa-shore__view img{max-width:100%;max-height:92vh;max-height:92dvh;width:auto;height:auto;border-radius:10px;display:block}' +
    '@media (min-width:990px){.sa-shore.sa-shore__in{grid-column:2;grid-row:2;align-self:start;margin-top:6px}.sa-colors.has-shore .sa-colors__copy{grid-row:1 / span 2}.sa-colors.has-shore .sa-colors__stage{align-self:end}}' +
    '@media (max-width:749px){.sa-shore.sa-shore__in{max-width:64%}.sa-shore__still{height:22px}.sa-shore__line{font-size:12px}.sa-shore__in .sa-shore__cap{gap:8px;flex-wrap:wrap}.sa-shore__world.is-open{order:3;flex-basis:100%;justify-content:flex-end;padding-top:2px}.sa-shore__world.is-open + .sa-shore__snd{margin-left:auto}}';
  document.head.appendChild(css);
  if (stills.length) {
    var row = el('div', 'sa-shore__stills');
    function sized(u, w) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    stills.forEach(function (st) {
      var b = el('button', 'sa-shore__still'); b.type = 'button'; b.setAttribute('aria-label', 'View photo: ' + st[3]);
      b.style.aspectRatio = st[1] + ' / ' + st[2];
      var im = el('img'); im.alt = st[3]; im.loading = 'lazy'; im.decoding = 'async'; im.width = st[1]; im.height = st[2];
      im.src = sized(st[0], 200);
      b.appendChild(im);
      b.addEventListener('click', function () { view(st); document.dispatchEvent(new CustomEvent('sa-shore-still')); });
      row.appendChild(b);
    });
    cap.insertBefore(row, world);
  }
  function view(st) {
    var o = el('div', 'sa-shore__view'); o.setAttribute('role', 'dialog'); o.setAttribute('aria-label', st[3]); o.tabIndex = -1;
    var im = el('img'); im.alt = st[3]; im.src = st[0]; im.width = st[1]; im.height = st[2];
    o.appendChild(im); document.body.appendChild(o); o.focus();
    requestAnimationFrame(function () { o.classList.add('is-on'); });
    function shut() { document.removeEventListener('keydown', key); o.classList.remove('is-on'); setTimeout(function () { o.remove(); }, 360); }
    function key(e) { if (e.key === 'Escape') shut(); }
    o.addEventListener('click', shut); document.addEventListener('keydown', key);
  }

  var loaded = false, seen = false, g = glow.getContext('2d');
  function load() { if (loaded) return; loaded = true; v.src = src; v.load(); }
  function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function paintGlow() { try { g.drawImage(v, 0, 0, 32, 18); } catch (e) {} }
  var last = 0;
  function tick(t) {
    if (seen && !v.paused) {
      if (t - last > 160) { last = t; paintGlow(); }
      if (v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration).toFixed(4) + ')';
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
  v.addEventListener('loadeddata', function () { wrap.classList.add('is-ready'); paintGlow(); });
  v.addEventListener('playing', function () { wrap.classList.add('is-ready'); });

  function musicOn() { return (window.saAudios || []).some(function (a) { return a && !a.paused; }); }
  function sound(on) {
    v.muted = !on; v.volume = musicOn() ? 0.35 : 0.8;
    snd.setAttribute('aria-pressed', on ? 'true' : 'false');
    wrap.classList.toggle('is-loud', on);
    if (on) { load(); play(); }
  }
  snd.addEventListener('click', function () { sound(v.muted); });
  frame.addEventListener('click', function () {
    if (v.paused) { load(); play(); return; }
    if (calm) { v.pause(); return; }
    sound(v.muted);
  });

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '900px 0px' }).observe(wrap);
    new IntersectionObserver(function (es) {
      seen = es[0].isIntersecting;
      if (seen) { if (!calm) play(); }
      else { v.pause(); if (!v.muted) sound(false); }
    }, { threshold: 0.25 }).observe(frame);
  } else { load(); if (!calm) play(); }
  document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); else if (seen && !calm) play(); });
})();
